export default __webpack_public_path__ + "static/media/reactjs.b603ee1a.jpg";